

// Attention: Wallets with IDs for connectors
export enum Wallets {
  METAMASK = 'io.metamask',
  TokenPocket = 'pro.tokenpocket',
  WalletConnect = 'walletConnect',
  TrustWallet = 'com.trustwallet.app',
}

export const walletsMap: Record<Wallets, { id: Wallets; name: string }> = {
  [Wallets.METAMASK]: {
    id: Wallets.METAMASK,
    name: 'Metamask',
  },
  [Wallets.WalletConnect]: {
    id: Wallets.WalletConnect,
    name: 'Wallet Connect',
  },
  [Wallets.TrustWallet]: {
    id: Wallets.TrustWallet,
    name: 'Trust Wallet',
  },
  [Wallets.TokenPocket]: {
    id: Wallets.TokenPocket,
    name: 'Token Pocket',
  },
};